<div class="container my-4 row">

  <app-config-line>
    <div body class="panel-izq-container h-100">
      <div class="panel-izq-form">
        <!-- Perfil y correo -->
        <div class="text-center mb-4">
          <div class="profile-picture-container">
            <span class="one-character-circled profile-picture">{{ userDataService.firstLetter }}</span>
          </div>
          <div class="mt-2 gl-text-secondary">
            <span>{{ userDataService.userEmail }}</span>
          </div>
        </div>
  
      </div>
  
    </div>
  </app-config-line>

  <app-config-line
    [title]="'Usuario: ' + userDataService.userName"
    [description]="'Nombre completo del usuario registrado en el sistema'"
    [withHr]="false"
  ></app-config-line>

  <app-config-line
    [title]="('CONFIGURATION.SECTIONS.USER.USER_PROFILE.COMPANY' | translate) + ': ' + userDataService.companyName"
    [description]="'Nombre de la empresa a la que pertenece el usuario'"
  ></app-config-line>

  <app-config-line
    [title]="('CONFIGURATION.SECTIONS.USER.USER_PROFILE.EMAIL' | translate) + ': ' + userDataService.userEmail"
    [description]="'Dirección de correo electrónico asociada a la cuenta del usuario'"
  ></app-config-line>

</div>